import type { FC } from 'react';
import React from 'react';
import type { Theme } from '@material-ui/core/styles';
import {
  makeStyles, createStyles,
} from '@material-ui/core/styles';
import {
  Typography, ListItemAvatar, Avatar, ListItemText, MenuItem,
} from '@material-ui/core';
import {
  Flag as FlagIcon,
  Notifications as NotificationsIcon,
  FiberManualRecord as FiberManualRecordIcon,
} from '@material-ui/icons';
import type { Message } from './NotificationTypes';

const useStyles = makeStyles((theme: Theme) => createStyles({
  menuItem: {
    marginBottom: 0,
    '&:last-child': {
      borderBottom: 'none',
    },
    '&:focus, &:hover': {
      backgroundColor: '#D6E1EF',
    },
    '.MuiTypography-root': {
      marginBottom: 0,
    },
  },
  primaryText: {
    marginBottom: '.125em',
    fontWeight: 700,
  },
  secondaryText: {
    margin: 0,
  },
  touchDot: {
    color: theme.palette.warning.main,
    fontSize: 10,
  },
  blue: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.info.contrastText,
  },
  red: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.secondary.contrastText,
  },
}));

interface MessageProps {
  message: Message,
  onClickFunction: () => void
}

const MessageItem: FC<MessageProps> = ({ message, onClickFunction }) => {
  const classes = useStyles();

  return (
    <MenuItem onClick={onClickFunction} className={classes.menuItem} divider>
      <ListItemAvatar>
        <Avatar className={message.type === 'alert' ? classes.red : classes.blue}>
          {message.type === 'alert' ? (
            <FlagIcon fontSize="small" />
          ) : (
            <NotificationsIcon fontSize="small" />
          )}
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={<Typography variant="h6" color="primary" className={classes.primaryText}>{message.title}</Typography>}
        secondary={message.created instanceof Date ? message.created : new Date(`${message.created}z`).toLocaleString()}
        classes={{
          primary: classes.primaryText,
          secondary: classes.secondaryText,
        }}
      />
      {!message.acknowledged && (
        <FiberManualRecordIcon className={classes.touchDot} />
      )}
    </MenuItem>
  );
};
export default MessageItem;
